import { _callBackend } from '@/_api/api';
import type { APIRequest, APIResponsePromise } from '@/_types/api';
import { FirmRole, FirmRoleAssignment } from '@/_types/models/firmRole';

export const addFirmRole = async ({
  companyId,
  firmRoleId,
  userId,
  token,
}: APIRequest<{
  companyId?: number;
  firmRoleId: number;
  userId: number;
}>): APIResponsePromise<{ id: number; firm_role_id: number }> =>
  await _callBackend(
    '/firm_role_assignments',
    'POST',
    {
      firm_role_id: firmRoleId,
      company_id: companyId,
      user_id: userId,
    },
    token,
  );

export const bulkAddFirmRoles = async ({
  companyIds,
  firmRoleId,
  userId,
  token,
}: APIRequest<{
  companyIds: Array<number>;
  firmRoleId: number;
  userId: number;
}>): APIResponsePromise<{ success: boolean; affected_rows: number }> =>
  await _callBackend(
    '/firm_role_assignments/bulk_add_roles',
    'POST',
    {
      firm_role_id: firmRoleId,
      company_ids: companyIds,
      user_id: userId,
    },
    token,
  );

export const removeFirmRole = async ({
  companyId,
  firmRoleId,
  token,
}: APIRequest<{
  companyId: number;
  firmRoleId: number;
}>): APIResponsePromise<FirmRole> =>
  await _callBackend(
    '/firm_role_assignments/remove_role',
    'DELETE',
    { company_id: companyId, firm_role_id: firmRoleId },
    token,
  );

export const bulkRemoveFirmRoles = async ({
  companyIds,
  firmRoleId,
  userId,
  token,
}: APIRequest<{
  companyIds: Array<number>;
  firmRoleId: number;
  userId: number | undefined;
}>): APIResponsePromise<{ success: boolean; affected_rows: number }> =>
  await _callBackend(
    '/firm_role_assignments/bulk_remove_roles',
    'DELETE',
    {
      company_ids: companyIds,
      firm_role_id: firmRoleId,
      user_id: userId || undefined,
    },
    token,
  );

export const deleteFirmRoleAssignment = async ({
  firmRoleId,
  userId,
  token,
}: APIRequest<{
  firmRoleId: number;
  userId: number;
}>): APIResponsePromise<{
  firm_role: FirmRole;
  affected_rows: number;
}> =>
  await _callBackend(
    '/firm_role_assignments/delete_assignment',
    'DELETE',
    { firm_role_id: firmRoleId, user_id: userId },
    token,
  );

export const getFirmRoleAssignments = async ({
  page,
  per_page = 20,
  token,
}: APIRequest<{
  page: number;
  per_page?: number;
}>): APIResponsePromise<{
  firmRoleAssignments: Array<FirmRoleAssignment>;
  count: number;
}> =>
  await _callBackend(
    `/firm_role_assignments?page=${page}&per_page=${per_page}`,
    'GET',
    null,
    token,
  );
